import React from 'react'
import InputCondition from "./input-condition";
import { XMarkIcon } from "@heroicons/react/24/outline";
import StandardRuleSourceSelect from "./standard-rule-source-select";

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export default function StandardRuleRow({ ruleset, rule, index, handleUpdate, handleShowDeleteModal }) {
  const {
    attributes,
    listeners,
    transform,
    transition,
    setNodeRef,
    setDraggableNodeRef,
    isDragging
  } = useSortable({
    id: rule.id,
  });

  function handleSelectChange(e) {
    e.preventDefault();
    updateRuleField('strategy', e.target.value)
  }

  function updateRuleField(field, value) {
    handleUpdate(index, rule, {[field]: value})
  }

  function handleDelete(e) {
    e.preventDefault();
    handleShowDeleteModal(index, rule)
  }

  return (
    <tr
      ref={setNodeRef}
      {...attributes}
      style={{
        transform: CSS.Translate.toString(transform),
        transition, // from useSortable
        zIndex: isDragging ? 1 : 0,
        position: isDragging ? 'relative' : undefined,
      }}
    >
      <td className="whitespace-nowrap text-sm text-gray-500">
        { index === 0 ? (<span className="px-3 py-4">{index + 1}</span>) : (
          <button ref={setDraggableNodeRef} {...listeners} className="sortable-btn drag-handle px-3 py-4">
            <span className="btn-label">{index + 1}</span>
            <span className="grip" aria-hidden="true">⠿</span>
          </button>
        )}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        <StandardRuleSourceSelect
          rule={rule}
          ruleset={ruleset}
          updateField={updateRuleField}
        />
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        { ruleset.policy_type === 'def_rebate' ? <span>Retail Minus</span> : (
          <select
            value={rule.strategy}
            onChange={handleSelectChange}
            className="w-full border-none focus:outline-none focus:ring-0 focus:border-none"
          >
            <option value="better_of">Better Of</option>
            <option value="cost_plus">Cost Plus</option>
            <option value="retail_minus">Retail Minus</option>
          </select>
        )}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        <InputCondition
          value={rule.cost_plus}
          field="cost_plus"
          condition={rule.strategy === "better_of" || rule.strategy === "cost_plus"}
          updateRuleField={updateRuleField}
        />
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        <InputCondition
          value={rule.retail_minus}
          field="retail_minus"
          condition={rule.strategy === "better_of" || rule.strategy === "retail_minus"}
          updateRuleField={updateRuleField}
        />
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        { index > 0 && (
          <button
            onClick={handleDelete}
            type="button"
            className="rounded-full bg-white p-1.5 text-gray-500 shadow-sm hover:bg-red-100 hover:text-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          >
            <XMarkIcon className="size-3" />
          </button>
        )}
      </td>
    </tr>
  )
}
